define([
	'internal_util/Util'
], function (
	Util
) {
	'use strict';

	/**
	 * Abstract RecoveryStrategy class
	 */
	return function (id) {
		var _id;

		if (Util.isValidURL(id)) {
			_id = id;
		} else {
			throw new Error('invalid recovery strategy id: ' + id);
		}


		// public methods

		this.id = function () {
			return _id;
		};

		this.name = function () {
			throw new Error('not implemented');
		};

		this.icon = function () {
			throw new Error('not implemented');
		};
		
		this.description = function () {
			throw new Error('not implemented');
		};

		this.isUsable = function (authenticationOption) {
			throw new Error('not implemented');
		};

		this.start = function (authenticationOption, callbacks, errorCallbacks) {
			throw new Error('not implemented');
		};

		this.stop = function () {
			throw new Error('not implemented');
		};

		this.toObject = function () {
			return _id;
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/RecoveryStrategy.js
// module id = 64
// module chunks = 3